import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ControlLabel } from "components/bootstrap";
import { Spinner } from "components/common";
import { Col, Row } from "common/components/layout-styles";
import { useGetAssetsByIds } from "security-app/hooks/useAssetsAPI";
import usePermissions from "hooks/usePermissions";
import AssetLink from "./AssetLink";
const StyledControlLabel = styled(ControlLabel)`
  margin: 0;
  white-space: nowrap;
`;
const SCROLLABLE_ROW_HEIGHT = 35;
const SCROLLABLE_STYLE = { overflow: "auto", height: SCROLLABLE_ROW_HEIGHT };
function AssocAssetsList({ assetIds, direction = "row", label }) {
  const { t } = useTranslation("enterprise_security_assets");
  const { isPermitted } = usePermissions();
  const canReadAssets = isPermitted("asset:read");
  const assetIdsToFetch = canReadAssets ? assetIds : [];
  const { assets, fetchingAssets } = useGetAssetsByIds(assetIdsToFetch);
  const ColRow = direction === "row" ? Row : Col;
  if (!canReadAssets) {
    return /* @__PURE__ */ React.createElement(ColRow, { $gap: "sm" }, label && /* @__PURE__ */ React.createElement(StyledControlLabel, null, label), /* @__PURE__ */ React.createElement(ColRow, { $gap: "xs" }, /* @__PURE__ */ React.createElement("em", null, t("assoc_assets_list.missing_permission"))));
  }
  if (fetchingAssets) return /* @__PURE__ */ React.createElement(Spinner, { text: t("assoc_assets_list.loading") });
  if ((assets == null ? void 0 : assets.length) < 1) return null;
  return /* @__PURE__ */ React.createElement(ColRow, { $gap: "sm" }, label && /* @__PURE__ */ React.createElement(StyledControlLabel, null, label), /* @__PURE__ */ React.createElement(ColRow, { $gap: "xs", style: direction === "row" ? SCROLLABLE_STYLE : void 0 }, assets.map((asset) => /* @__PURE__ */ React.createElement(AssetLink, { key: asset.id, asset }))));
}
export default AssocAssetsList;
